<template>
  <div>
  <el-dialog title="添加" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form size="small" :model="form" :rules="formRules" ref="form">

      <!--类型-->
      <el-form-item label="类型" prop="type" :label-width="formLabelWidth">
        <el-select v-model="form.type" @change="typeChange">
          <el-option label="顶级" value=""></el-option>
          <el-option :value="item.key_name" :label="item.name" :key="item.key_name" v-for="item in typeData"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="数量" prop="code_count" :label-width="formLabelWidth">
        <el-input v-model.number="form.code_count" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item label="解锁范围" :label-width="formLabelWidth">
        <!-- <p v-if="form.type == 60">【模拟考试】解锁每张卷</p> -->
        <!-- <p v-if="form.type == 83">【精品课程】解锁某分类</p> -->
        <p v-if="form.type == 82">【刷题】解锁所有视频解析(一次性)</p>
        <p v-else-if="form.type == 81">【考研择校】解锁高级筛选(一次性)</p>
        <div v-else-if="form.type>0 && roleData">
          <p>选择以下角色 <span class="red">(必选)</span></p>
          <el-checkbox-group v-model="form.role_ids">
            <el-checkbox v-for="(item,index) in roleData" :key="index" :label="item.role_id" >{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </div>
      </el-form-item>

      <!-- <el-form-item label="角色" prop="role_ids" :label-width="formLabelWidth">
        <el-checkbox-group v-model="form.role_ids" v-if="roleData">
          <el-checkbox v-for="(item,index) in roleData" :key="index" :label="item.role_id" >{{item.name}}</el-checkbox>
        </el-checkbox-group>
        <div class="gray9"></div>
      </el-form-item> -->

      <!-- <el-form-item label="状态" :label-width="formLabelWidth">
          <el-radio-group v-model="form.status">
          <el-radio :label="1">显示</el-radio>
          <el-radio :label="0">隐藏</el-radio>
          </el-radio-group>
      </el-form-item> -->
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="addFun" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>

  </div>
</template>

<script>
  import CodeApi from '@/api/study/code.js';
  import CodeRoleApi from '@/api/study/code_role.js';
  export default {
    data() {
      return {
        form: {
          type: '',
          code_count: 0,
          role_ids: []
        },
        formRules: {
          type: [{ required: true, message: '请选择类型', trigger: 'blur' }],
          code_count: [{ type: 'number', required: true, message: '请输入数量' }, { type: 'number', min: 1, message: '请数量大于0' }],
          role_ids: [{ required: true, message: '请选择角色', trigger: 'blur' }],
        },
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,
        loading: false,
        type: '',
        roleData: [],
      };
    },
    props: ['open_add', 'typeData'],
    created() {
      this.dialogVisible = this.open_add;
    },
    methods: {
      /*选择类型*/
      typeChange(){
        let self = this;
        CodeRoleApi.getList({type:this.form.type, is_page:0}, true).then(res => {
            if (res.code == 1) {
                self.roleData = res.data.list
            }
        });
      },
      /*添加*/
      addFun() {
        let self = this;
        let params = this.form;
        if ([81,82].indexOf(params.type) == -1){
          if (!params.role_ids.length){
            self.$message({
              message: '解锁范围必选',
              type: 'warning'
            });
            return;
          }
        }
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            CodeApi.add(params, true).then(data => {
                self.loading = false;
                self.$notify({
                  title: data.msg,
                  type: 'success',
                });
                self.dialogFormVisible(true);
              })
              .catch(error => {
                self.loading = false;                
              });
          }
        });

      },

      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },

    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/study/code/code/part/Add.vue